// extracted by mini-css-extract-plugin
export default {"overlay":"mobileModal_overlay__LLFdW","modal":"mobileModal_modal__VkTKx"};